// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const map = gql`
  query map($panelCollectionName: String!) {
    map(panelCollectionName: $panelCollectionName)
      @rest(
        type: "LiveDataMap"
        path: "livedata/collections/{args.panelCollectionName}/map?template={args.panelCollectionName}"
      ) {
      bounds @type(name: "LiveDataMapBoundingBox") {
        minX
        maxX
        minY
        maxY
        centerY
        centerX
      }
      items @type(name: "LiveDataMapListItem") {
        imagePath
        name
        id
        formattedTimeStamp
        latitude
        longitude
        values @type(name: "LiveDataMapListItemValue") {
          # subclass
          iconURL
          formattedValue
          # valueChangeState
          value
          textStyle
        }
        miniPanelURL
        markerColor
        mapInstrumentURL
        isEnlargable
      }
    }
  }
`;

export default map;
